// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--3jX0n","compact":"styles-module--compact--3nGwd","katacodaIcon":"styles-module--katacodaIcon--2kAKt"};